export default __webpack_public_path__ + "static/media/purchase_order.f1aff4f6.jpg";